@let selectable = $selectable();
@if (selectable) {
  @let textField = $textField();
  @let control = $control();

  <unity-control-wrapper [control]="control" [description]="$description()" [displayName]="$displayName()" [showHint]="$showHint()">
    <kendo-dropdownlist
      #dropdownlist
      unityClearableDropdownlist
      valueField="id"
      [data]="selectable | sort: $defaultSortCfg()"
      [showStickyHeader]="false"
      [textField]="textField"
      [valuePrimitive]="true"
      [formControl]="control"
      [readonly]="$readonly()"
      [defaultItem]="$currentSelection()"
      (clearedEvent)="reset()"
      (selectionChange)="onSelectionChange($event)">
      <ng-template kendoDropDownListNoDataTemplate> Nothing available to select </ng-template>
      <ng-template let-item kendoDropDownListValueTemplate>
        @let isDisabled = $isDisabled();
        @if (item && isDisabled === true) {
          <span>
            <a name="link" class="selection inline underline k-link" [routerLink]="[$linkRoot(), item[$linkField()]]">
              {{ item[textField] }}
            </a>
          </span>
        }
        @if (item && !isDisabled) {
          <span name="normal" class="selection inline">
            {{ item[textField] }}
          </span>
        }
        @if (!item) {
          <span name="none" class="selection inline italic"> (no selection) </span>
        }
      </ng-template>
    </kendo-dropdownlist>
  </unity-control-wrapper>
} @else {
  <kendo-loader type="infinite-spinner" size="medium" themeColor="info" />
}
